import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$subscriptionId/fraud-analysis/models',
      params,
      replace: true,
    })
  },
})
